"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.start.recording': '开始录音',
    'conversation.start.failed': '对话启动失败',
};
